module.exports = __webpack_public_path__ + "img/gb960.prt.070f467d.jpg";